import { enumBoxWidthMode } from "../constants";

export function HSizingModeToStringCode(sizingMode) {
  switch (sizingMode) {
    case enumBoxWidthMode.autoself:
      return "autoself";
    case enumBoxWidthMode.autosmart:
      return "autosmart";
    case enumBoxWidthMode.autochildren:
      return "autochildren";
    default:
      return "Fixed";
  }
}
